<script setup lang="ts">
const config = useRuntimeConfig();
</script>

<template>
	<div class="flex items-center py-1 px-[10px]">
		<NuxtImg
			src="img/logo.svg"
			fit="cover"
			width="32"
			height="32"
			alt="logo"
		/>
		<span class="ml-3 font-semibold text-base">
			{{ config.public.companyName }}
		</span>
	</div>
</template>
